module.exports = __webpack_public_path__ + "static/media/car-video.4297eadf.mp4";